import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    matrix: {}
};

const matrixAnswerSlice = createSlice({
    name: "matrixAnswers",
    initialState,
    reducers: {
        setMatrixAnswer(state, action) {
            const { questionId, subOptionId, optionId } = action.payload;

            if (!state.matrix[questionId]) {
                state.matrix[questionId] = [];
            }

            state.matrix[questionId] = state.matrix[questionId].filter(
                ans => ans.subOptionId !== subOptionId
            );

            state.matrix[questionId].push({
                questionId,
                subOptionId,
                optionId
            });
        },
    }
});

export const { setMatrixAnswer } = matrixAnswerSlice.actions;
export default matrixAnswerSlice.reducer;
